export const PRIMARY_BLUE_COLOR = '#17B3C5'
